export default function extractUrlParameter(returnParam = null, search) {
  let param = null

  if (search && returnParam) {
    search
      .substring(1)
      .split('&')
      .forEach(p => {
        const keyValue = p.split('=')
        const key = keyValue[0]
        const value = keyValue[1]
        if (key === returnParam) {
          param = value
        }
      })
  }

  return param
}
